import * as React from 'react'
import { DVString } from '@utils'
import * as styles from './Offers.module.scss'
import { Text as DVStringProcessor } from 'DVWebNodeUI'

interface offersProps {
    offers: DVString[]
}

export const Offers = (props: offersProps) => (
    <div className={styles.offers}>
        {props.offers.map(offer =>
            (<DVStringProcessor string={offer} className={styles.offer} />))}
    </div>
)